(() => {
  const initSlider = (root) => {
    if (!root || root.dataset.mdSliderReady === 'true') return;

    const track = root.querySelector('[data-md-slider-track]');
    const slides = Array.from(root.querySelectorAll('[data-md-slide]'));
    const prev = root.parentElement?.querySelector('[data-md-prev]') || root.querySelector('[data-md-prev]');
    const next = root.parentElement?.querySelector('[data-md-next]') || root.querySelector('[data-md-next]');
    const dots = root.querySelector('[data-md-dots]') || root.parentElement?.querySelector('[data-md-dots]');

    if (!track || slides.length === 0) return;
    root.dataset.mdSliderReady = 'true';

    let activeIndex = 0;
    let dotButtons = [];

    const getLeft = (slide) => Math.max(0, slide.offsetLeft - track.offsetLeft);
    const getMaxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = () => track.scrollLeft <= 4;
    const atEnd = () => track.scrollLeft >= getMaxScroll() - 4;

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dotButtons.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    };

    const goTo = (index) => {
      const normalized = (index + slides.length) % slides.length;
      track.scrollTo({ left: getLeft(slides[normalized]), behavior: 'smooth' });
      setActive(normalized);
    };

    if (dots) {
      dots.innerHTML = '';
      dotButtons = slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'md-hb__slider-dot';
        dot.setAttribute('aria-label', `Ga naar slide ${index + 1}`);
        dot.addEventListener('click', () => goTo(index));
        dots.appendChild(dot);
        return dot;
      });
      setActive(0);
    }

    prev?.addEventListener('click', () => {
      if (atStart()) {
        goTo(slides.length - 1);
        return;
      }
      goTo(activeIndex - 1);
    });

    next?.addEventListener('click', () => {
      if (atEnd()) {
        goTo(0);
        return;
      }
      goTo(activeIndex + 1);
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const scrollLeft = track.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(getLeft(slide) - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setActive(closestIndex);
        ticking = false;
      });
    }, { passive: true });
  };

  const initWhyMore = (root) => {
    if (!root || root.dataset.mdWhyReady === 'true') return;

    const toggle = root.querySelector('[data-md-why-toggle]');
    const label = root.querySelector('[data-md-why-toggle-label]');
    if (!toggle || !label) return;

    root.dataset.mdWhyReady = 'true';

    toggle.addEventListener('click', () => {
      const expanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? 'Lees minder' : 'Lees meer';
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-md-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-md-why-more]').forEach(initWhyMore);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
